import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import ActionButton from "../../../components/ActionButton";
import TextAreaInputField from "../../../components/forms/TextAreaInputField";
import FormError from "../../../components/forms/FormError";

class ReasonForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <p>Please specify a reason why you are removing product {this.props.productId} from the shop.</p>
          <FormFieldsTable>
            <Field 
              label="Reason"
              name="reason"
              component={TextAreaInputField}
              serverError={this.props.errors.reason}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "ReasonForm"
})(ReasonForm);

export default ReduxForm;